import React from "react"
import Geocode from "react-geocode"
import CheckSteps from "../../CheckSteps"
import "./Lalamove.css"
import { DateField, TimeField, MapField } from "../../../common/Fields"
import { FastField } from "formik"
import moment from "moment"
import { getAllTimes } from "../../../common/utils"
import "./Lalamove.css"

Geocode.setApiKey("AIzaSyBQfWJeb8rqL6YXiSWmT52svZhDlSuY_XU")
Geocode.enableDebug()

const timeList = getAllTimes().map(time => ({
  value: time.value,
  label: `${time.time} ${time.meridiem}`
}))

const validateLocation = value => {
  let error
  if (!value) {
    error = "Please enter a location."
  }
  return error
}

const validateDeliveryDate = value => {
  let error
  if (!value) {
    error = "Please enter a preferred date."
  }
  return error
}

const validateDeliveryTime = value => {
  let error
  if (!value) {
    error = "Please enter a preferred time."
  }
  return error
}

function Lalamove(props) {
  return (
    <div className="Lalamove">
      <CheckSteps
        steps={props.steps}
        setSteps={props.setSteps}
        value="shipping"
      />
      <div className="lalamap">
        <FastField
          component={MapField}
          type="delivery"
          name="deliveryLocation"
          value={props.values.deliveryLocation}
          validate={validateLocation}
          viewOnly={props.isSubmitting}
        />
      </div>
      <div className="delivery">
        <div>
          <label>Delivery Date</label>
          <FastField
            component={DateField}
            name="deliveryDate"
            value={props.values.deliveryDate}
            validate={validateDeliveryDate}
            minDate={moment()}
            maxDate={null}
            selected={null}
            disabled={props.isSubmitting}
          />
        </div>
        <div>
          <label>Delivery Time</label>
          <FastField
            component={TimeField}
            name="deliveryTime"
            options={timeList}
            defaultValue={[{ value: "", label: "" }]}
            validate={validateDeliveryTime}
            value={props.values.deliveryTime}
            disabled={props.isSubmitting}
          />
        </div>
      </div>
    </div>
  )
}

export default Lalamove
